// extracted by mini-css-extract-plugin
module.exports = {"borderArea":"AbxXQ","borderAreaHover":"_1P2qx"};